export default __webpack_public_path__ + "static/Cover-blue-8fa60f9e604db93cc4711a741f0ae055.png";